import M from 'messages';

export default [
  {
    value: 'public',
    title: M.get('table.tasteimonials.filter.status.public'),
  },
  {
    value: 'private',
    title: M.get('table.tasteimonials.filter.status.private'),
  },
];
